import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '72px' }}>
      <div style={{ textAlign: 'center', padding: '48px 24px' }}>
        <p className="tag" style={{ marginBottom: '16px', display: 'block' }}>Page Not Found</p>
        <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: '80px', color: 'var(--cream-darker)', lineHeight: 1, marginBottom: '16px' }}>404</h1>
        <p style={{ fontSize: '16px', color: 'var(--gray)', marginBottom: '32px', maxWidth: '360px', margin: '0 auto 32px' }}>
          This page doesn't exist. It may have been moved or the link may be incorrect.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Link to="/" className="btn-primary">Go to Homepage</Link>
          <Link to="/catalogue" className="btn-secondary">Browse Catalogue</Link>
        </div>
      </div>
    </div>
  );
}
